import startImg from "../../../assets/loan-interactive/instruction/play_icon.png";
import pauseImg from "../../../assets/loan-interactive/instruction/pause_icon.png";

function InsEN() {
  return (
    <>
      <h1 style={{ paddingBottom: "2rem" }}>What is a Loan?</h1>
      <p style={{ paddingBottom: "1.5rem" }}>
        Hello there! Welcome to Quick Learning Tool No. 4: What is a Loan?
      </p>

      <p style={{ paddingBottom: "3.5rem" }}>
        In the world of managing money, it's crucial to grasp the basics of a
        loan.
      </p>

      <h2 style={{ paddingBottom: "2rem" }}>Activity Instructions</h2>
      <p style={{ paddingBottom: "2rem" }}>
        Start by clicking on the "Start" button to enter the interactive map.
      </p>

      <p style={{ paddingBottom: "2rem" }}>
        You will find five clickable vendors on the map. Click on "Manang Dang:
        Fishmonger" vendor first to start the learning journey. Follow this
        order accordingly:
      </p>

      <ol style={{ paddingBottom: "2rem" }}>
        <li>1. Manang Dang: Fishmonger</li>
        <li>2. Mareng Risa: Rice Dealer</li>
        <li>3. Madam Burda: Handicraftsman</li>
        <li>4. Ate Pan: Bakery Owner</li>
        <li>5. Kuya Pau: Loan Officer</li>
      </ol>

      <p style={{ paddingBottom: "2rem" }}>
        Once you click a vendor, a conversation will open up. Read it carefully.
      </p>

      <p style={{ paddingBottom: "2rem" }}>
        At some point, you will be presented with multiple-choice questions
        related to the loan basics discussed. Answer the questions to proceed.
      </p>

      <p style={{ paddingBottom: "2rem" }}>
        If you need to pause, click this icon
        <img
          src={pauseImg}
          alt="pasue"
          style={{
            cursor: "pointer",
            marginLeft: "5px",
            height: ".7rem",
          }}
        />
        . This temporarily stops the current conversation. Click
        <img
          src={startImg}
          alt="start"
          style={{
            cursor: "pointer",
            marginLeft: "5px",
            marginRight: "5px",
            height: ".7rem",
          }}
        />
        to continue from where you left off.
      </p>
    </>
  );
}
export default InsEN;
